import * as THREE from 'three';
import BaseMesh from '../BaseMesh.js';

const getFont = (size) => {
  return `normal ${size}px Arial`;
};

// hack: 计算字的高度: https://stackoverflow.com/questions/1134586/how-can-you-find-the-height-of-text-on-an-html-canvas
const getTextSize = (props) => {
  const { text, size } = props;
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.font = getFont(size);
  const width = ctx.measureText(text).width;
  const height = ctx.measureText('M').width;
  return { width, height };
};

class Index extends BaseMesh {
  constructor(data) {
    super(data);
    this._drawAll();
  }

  _drawAll() {
    const drawText = (canvas, color, size, text, padding, height, opacity = 1) => {
      // draw text: 水平，垂直都居中
      // https://stackoverflow.com/questions/13771310/center-proportional-font-text-in-an-html5-canvas
      // https://www.cnblogs.com/amtf/archive/2012/01/18/2324343.html
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = color;
      ctx.font = getFont(size);
      ctx.textBaseline = 'middle';
      ctx.fillText(text, padding, height / 2);
      const canvasTexture = new THREE.CanvasTexture(canvas);
      canvasTexture.needsUpdate = true;
      // update this.material
      this.material = new THREE.MeshBasicMaterial({
        map: canvasTexture,
        side: THREE.FrontSide,
        transparent: true,
        depthTest: false,
        opacity
      });
    };

    const { text, size, color, opacity = 1, padding = 0 } = this.props;
    // compute text size
    let { width, height } = getTextSize(this.props);
    width += padding * 2;
    height += padding * 2;
    // update this.geometry
    this.geometry = new THREE.PlaneGeometry(width, height);
    // create canvasTexture
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff00';
    ctx.fillRect(0, 0, width, height);

    const { backgroundImage } = this.props;
    if (backgroundImage) {
      const img = new Image();
      img.src = backgroundImage.url;
      img.onload = () => {
        ctx.drawImage(img, 0, 0, width, height);
        drawText(canvas, color, size, text, padding, height, opacity);
      };
    } else {
      drawText(canvas, color, size, text, padding, height, opacity);
    }
  }

  updateProps(key, value) {
    super.updateProps(key, value);
    switch (key) {
      case 'static':
        break;
      case 'text':
      case 'size':
      case 'color':
      case 'padding':
      case 'backgroundImage':
        this._drawAll();
        break;
      case 'opacity':
        this.material.opacity = value;
        break;
    }
  }
}

export default Index;
